/**
 * Packshot PDF Service
 * handle pdf related functions
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Pdf { 
    id?: string;
    name?: string;
    objectStorePath?: string;
    checkSumType?: Pdf.CheckSumTypeEnum;
    checkSum?: string;
}
export namespace Pdf {
    export type CheckSumTypeEnum = 'MD5' | 'SHA-1' | 'SHA-256' | 'SHA-512';
    export const CheckSumTypeEnum = {
        MD5: 'MD5' as CheckSumTypeEnum,
        SHA1: 'SHA-1' as CheckSumTypeEnum,
        SHA256: 'SHA-256' as CheckSumTypeEnum,
        SHA512: 'SHA-512' as CheckSumTypeEnum
    };
}


